import angular from 'angular';
import uiRouter from 'angular-ui-router';
import FillComponent from './fill.component';
import routing from './fill.routes';

export default angular
  .module('verifyApp.cases.fill', [uiRouter])
  .config(routing)
  .component('fill', FillComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/cases/fill/index.js